const getIndustryApplicableWageSchedule = (wageSchedules, companyDoc) => Array.isArray(wageSchedules)
  ? wageSchedules.reduce((_result, schedule) => {
    if (schedule.industry.name === companyDoc.industry.name
      && (!schedule.industry.subIndustryName || schedule.industry.subIndustryName === companyDoc.industry.subIndustry.name)
      && (!schedule.industry.subSubIndustryName || schedule.industry.subSubIndustryName === companyDoc.industry.subIndustry.subIndustry.name)) {
      return schedule
    }
    if (_result.length === 0 && schedule.industry.name === 'Standard') return schedule

    return _result
  }, [])
  : []

const getEffectiveWageForDate = (wageSchedule, date) => wageSchedule.map((wage) => ({
  ...wage,
  effectiveDate: new Date(wage.effectiveDate)
}))
  .reduce((resultingWage, wage) => {
    if (wage.effectiveDate < date) return wage
    return resultingWage
  }, {})

module.exports = {
  getEffectiveWageForDate,
  getIndustryApplicableWageSchedule
}
